<template>
  <div
    v-if="extras1.formBgWap"
    class="banner-new"
    :style="{
      background:
        extras1.formBgWap.colorOrBg == 'color' ? extras.formBgWap.color : '',
    }"
  >
    <img
      :src="extras1.formBgWap.colorOrBg == 'src' ? extras.formBgWap.src : ''"
      alt=""
    />

    <div v-if="isSetting != 1">
      <div
        class="seminar-info"
        v-if="extras1 && extras1.seminarInfo.display == '1'"
      >
        <div class="seminar-info-new wap" :class="extras1.BannerText.textAlign">
          <div class="content">
            <div
              class="seminar-title"
              v-if="extras1.textSetting.subTitle != 'hide'"
              :style="{
                color:
                  extras1.textSetting.subTitle == 'custom'
                    ? extras1.textSetting.fontColor
                    : '',

                'font-style':
                  extras1.textSetting.subTitle == 'custom'
                    ? extras1.textSetting.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras1.textSetting.subTitle == 'custom'
                    ? extras1.textSetting.fontWeight == 'on'
                      ? '900'
                      : ''
                    : '',
              }"
            >
              {{ extras1.textSetting.text }}
            </div>
            <div
              class="seminar-slogan"
              v-if="extras1.textSetting.title != 'hide'"
              :style="{
                color:
                  extras1.textSetting.title == 'custom'
                    ? extras1.textSetting.fontColor2
                    : '',

                'font-style':
                  extras1.textSetting.title == 'custom'
                    ? extras1.textSetting.fontTilt2 == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  extras1.textSetting.title == 'custom'
                    ? extras1.textSetting.fontWeight2 == 'on'
                      ? '900'
                      : ''
                    : '',
              }"
            >
              {{
                extras1.textSetting.title == "default"
                  ? seminarInfo.title
                  : seminarInfo.title
              }}
            </div>
            <div class="semianr-time">
              <div
                class="_title"
                v-show="extras1.textSetting.timeTitle != 'hide'"
                :style="{
                  color:
                    extras1.textSetting.timeTitle == 'custom'
                      ? extras1.textSetting.fontColor3
                      : '',
                  background: extras1.textSetting.bgColor5 || '',
                  'font-style':
                    extras1.textSetting.timeTitle == 'custom'
                      ? extras1.textSetting.fontTilt3 == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'font-Weight':
                    extras1.textSetting.timeTitle == 'custom'
                      ? extras1.textSetting.fontWeight3 == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                }"
              >
                {{
                  extras1.textSetting.timeTitle == "custom"
                    ? extras1.textSetting.text3
                    : "会议时间"
                }}
              </div>
              <div
                class="_time"
                v-show="extras1.textSetting.time != 'hide'"
                :style="{
                  color:
                    extras1.textSetting.time == 'custom'
                      ? extras1.textSetting.fontColor4
                      : '',
                  background: extras1.textSetting.bgColor6 || '',
                  'font-style':
                    extras1.textSetting.time == 'custom'
                      ? extras1.textSetting.fontTilt4 == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'font-Weight':
                    extras1.textSetting.time == 'custom'
                      ? extras1.textSetting.fontWeight4 == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                }"
              >
                {{
                  handleTimeStamps(seminarInfo.startTime, seminarInfo.endTime)
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="banner-logo" v-if="extras1&&extras1.formLogo.display == '1'">-->
      <!--<img :src="extras1.headerLogo.src" alt="">-->
      <!--</div>-->
    </div>
    <div v-if="isSetting == 1">
      <div
        class="seminar-info"
        v-if="extras1 && extras1.seminarInfo.display == '1'"
      >
        <div class="seminar-info-new wap _left">
          <div class="content">
            <div class="seminar-title">会议副标题会议副标题</div>
            <div class="seminar-slogan">会议标会议标题</div>
            <div class="semianr-time">
              <div class="_title">会议时间</div>
              <div class="_time">2023-12-12 12:22-24:00</div>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="banner-logo" v-if="extras1&&extras1.formLogo.display == '1'">-->
      <!--<img :src="'./images/logo_new.png'" alt="">-->
      <!--</div>-->
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { isSetting } from "../common/sbase";
export default {
  name: "Banner",
  computed: {
    extras() {
      return this.$store.state.extras;
    },
    extras1() {
      return this.extras;
    },
  },
  data() {
    return {
      isSetting: isSetting,
    };
  },
  props: ["seminarInfo"],
  methods: {
    handleTimeStampToDateTime(timeStamp, format) {
      return moment(timeStamp).format(format);
    },
    handleTimeStamps(startTimeStamp, endTimeStamp) {
      let startTimeYear = this.handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY"
      );
      let endTimeYear = this.handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY"
      );
      let startDate = this.handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      let endDate = this.handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      if (startDate == endDate) {
        return (
          this.handleTimeStampToDateTime(
            startTimeStamp * 1000,
            "YYYY年MM月DD日 HH:mm"
          ) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, "HH:mm")
        );
      } else if (startTimeYear == endTimeYear) {
        return (
          this.handleTimeStampToDateTime(
            startTimeStamp * 1000,
            "YYYY年MM月DD日"
          ) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, "MM月DD日")
        );
      } else {
        return (
          this.handleTimeStampToDateTime(
            startTimeStamp * 1000,
            "YYYY年MM月DD日"
          ) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, "YYYY年MM月DD日")
        );
      }
    },
  },
};
</script>
